import { memo, useMemo } from 'react';
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import { commonStyles } from '../../common/styles';
import AppColors from '../../common/colors';
import { ContinueMovieItem } from '../../data/models/cinema';
import { VoidCb } from '../../types/others';
import localization from '../../common/localization';
import { CinemaProvider } from '../../data';
import States from '../../common/states';

type Props = {
  item?: ContinueMovieItem;
  start?: (item: ContinueMovieItem) => void;
  openDetails?: (id: number) => void;
  close?: VoidCb;
};

const ContinueWatchDialogMobile = memo<Props>(
  ({ item, start, openDetails, close }) => {
    const actions = useMemo(
      () => [
        () => {
          start?.(item!);
          close?.();
        },
        () => {
          openDetails?.(item!.id);
          close?.();
        },
        () => {
          CinemaProvider.removeFromHistory(item!.id).then(() => {
            States.contentState.updateHistory();
          });
          close?.();
        },
      ],
      [item, start, openDetails, close],
    );

    return (
      <Modal transparent visible={item !== undefined}>
        <View style={styles.container}>
          <Pressable onPress={close} style={commonStyles.fill} />
          <View style={styles.dialogContainer}>
            <Text style={styles.title}>{localization.general.menu}</Text>
            <MainDialogItem
              text={localization.settings.startAtBegin}
              onPress={actions[0]}
            />
            <MainDialogItem
              text={localization.settings.openDetails}
              onPress={actions[1]}
            />
            <MainDialogItem
              text={localization.settings.removeFromHistory}
              onPress={actions[2]}
            />
          </View>
        </View>
      </Modal>
    );
  },
);

type DialogAction = {
  text: string;
  onPress?: () => void;
};

const MainDialogItem = memo<DialogAction>(({ text, onPress }) => {
  return (
    <Pressable onPress={onPress} style={styles.actionContainer}>
      <Text style={styles.actionText}>{text}</Text>
    </Pressable>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: AppColors.semiBlack,
  },
  dialogContainer: {
    backgroundColor: AppColors.containerGray,
    marginHorizontal: 40,
    paddingTop: 24,
    paddingBottom: 12,
    paddingHorizontal: 24,
    borderRadius: 16,
  },
  title: {
    ...commonStyles.text,
    color: 'white',
    fontSize: 24,
    fontWeight: '700',
    marginBottom: 6,
    textAlign: 'center',
  },
  actionContainer: {
    alignItems: 'center',
    marginBottom: 12,
    paddingVertical: 16,
  },
  actionText: {
    ...commonStyles.text,
    color: 'white',
    fontSize: 16,
  },
});

export default ContinueWatchDialogMobile;
